import React, { useState, useEffect } from "react";

import { Row, Col, FormControl, Checkbox, Grid } from "react-bootstrap";

import { useMultiFilterContext } from "../../../../contexts/MultiFilterContext";
import { useEditCoachPoolContext } from "../../../../contexts/EditCoachPoolContext";

import FilterBlock from "./Filter/FilterBlock";

export default function Filters() {
  const { dispatch, actions, state } = useMultiFilterContext();
  const {
    dispatch: dispatchEditCoachPool,
    actions: actionsEditCoachPool,
    state: stateEditCoachPool,
  } = useEditCoachPoolContext();

  const clearAll = () => {
    actions.clearAllFilters(dispatch);
    actionsEditCoachPool.clearSelectedAll(dispatchEditCoachPool);
  };

  useEffect(() => {
    actions.loadFilters(dispatch);
  }, []);

  return (
    <div className="ibox-content filters search-coach-filter mt20">
      <div style={{ padding: "10px 25px" }}>
        {state.filters == null && <div>Please wait, filters loading ...</div>}
        {state.filters != null && (
          <>
            {state.filters.map((filterWrapper, index) => {
              return (
                <div key={index} className="dropdown">
                  <a className="green main-link">
                    {filterWrapper.title}
                    {actions.countSelectedItems(filterWrapper.category, state) >
                      0 && (
                      <span>
                        {actions.countSelectedItems(
                          filterWrapper.category,
                          state
                        )}
                      </span>
                    )}

                    <i className="fa fa-caret-down"></i>
                  </a>
                  <FilterBlock filterWrapper={filterWrapper} />
                </div>
              );
            })}
            <div className="dropdown inviteSearch_form">
              <input
                type="text"
                placeholder="Type First or Last Name here"
                value={state.coachName}
                onChange={(e) => {
                  actions.setCoachName(dispatch, e.target.value);
                  actionsEditCoachPool.clearSelectedAll(dispatchEditCoachPool);
                }}
                className="form-control filter-block"
              />
            </div>
            <div className="dropdown ml20">
              <Checkbox
                checked={state.showSelectedOnly}
                onChange={(e) => {
                  actions.setShowSelectedOnly(dispatch, e.target.checked);
                  actionsEditCoachPool.clearSelectedAll(dispatchEditCoachPool);
                }}
              >
                Show only selected
              </Checkbox>
            </div>
            <a
              onClick={clearAll}
              className="pull-right green clear-search-filter font-w-600 pull-right pt10"
            >
              <i className="fa fa-remove mr5"></i>
              Clear
            </a>
          </>
        )}
      </div>
    </div>
  );
}
